import axios from "axios";

const state = {
    CableDialog:false,
    CableItems:{},
    CableBundle:[]
};

const getters = {
    getCableDialog(state) {
    return state.CableDialog;
  },
  getCableItems(state){
    return state.CableItems; 
  },
  getCableGotvBundle(state){
    let newData = []
    state.CableBundle.forEach(element => {
      if(element.network == "GOTV"){
        newData.push(element)
      }
    });
    return newData
  },
  getCableDstvBundle(state){
    let newData = []
    state.CableBundle.forEach(element => {
      if(element.network == "DSTV"){
        newData.push(element)
      }
    });
    return newData
  }
};

const mutations = {
    setCableDialog(state, payload) {
    state.CableDialog = payload;
  },
  setCableItems(state, payload){
    state.CableItems = payload;  
  },
  setCableBundle(state, payload){
    state.CableBundle = payload;  
  }
};

const actions = {

  getCableBundle({commit}){
    commit("setLoading", true);
    commit("setSnackbar", false);
    axios.get("https://backoffice.teller.ng/api/GetIRechargeBundles")
    .then(res => {
    if (res.data.status == 0) {
      commit("setCableBundle", res.data.tv);
    }
    else{
        commit("setSnackbar", true);
        commit("setServerMessage", res.data.message)
    } 
  })
  .catch(err => {
    console.log(err)
    commit("setSnackbar", true);
    commit("setServerMessage", err.message)
  })
  .finally(()=>{
    commit("setLoading", false);
  })

  },


    loadCardDetail({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/api/TvValidationRequest?tvNetwork=${payload.network}&serviceCode=${payload.serviceCode}&smartcardNumber=${payload.SmartCard}&startimesAmount=${payload.amount *100}&imei=12345`)
      .then(res => {
          console.log(res.data)
        if (res.data.status == 0) {
          commit("setCableDialog", true);
          commit("setCableItems", res.data);
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err)
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  CardPayment({commit}, payload){
    commit("setCableDialog", false);
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/TvVendRequest?customerID=${payload.customerID}&pin=${payload.pin}&smartcardNumber=${payload.smartcardNumber}&tvNetwork=${payload.tvNetwork}&serviceCode=${payload.serviceCode}&accessToken=${payload.CableItems.accessToken}&referenceId=${payload.CableItems.referenceId}&customerPhone=${payload.customerPhone}&startimesAmount=${payload.amount*100}&imei='12344'`)
      .then(res => {
          console.log(res.data)
        if (res.data.status == 0) {
          commit("setCableDialog", false);
          commit("setCableItems", {});
          //commit("setSnackbar", true);
          //commit("setServerMessage", "Successful")
          payload.route.push({name: "Successful"})
        }
        else{
            commit("setSnackbar", true);
            commit("setCableDialog", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err)
        commit("setSnackbar", true);
        commit("setCableDialog", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};








